import {SLowcodeList} from "shj-components";

import {config} from './config.tsx'
import { getEnums, httpOrgList } from "@/services/homeService.ts";
import {departmentTree} from "@/services/content.ts";
import { useEffect, useRef } from "react";
import {getAllCompanyMrn} from "@/services/customerServices.ts";
import {getSeatWorkload} from "@/services/saleOpServices.ts";
import { getSeatAccountList } from "@/services/crmTool.ts";
import { getUser } from "shj-utils";

export default function Workload() {
  const listRef = useRef()
  const userInfo = getUser()

  useEffect(() => {
    if(userInfo?.userIdentity?.dataScope !== 'ALL') {
      onCompanyChange(userInfo.companyId)
    }
  }, [userInfo])

  const fetchList = ({query}) => {
    return new Promise((resolve, reject) => {
      if(query.time){
        query.startTime = query.time[0] ? query.time[0].format('YYYY-MM-DD 00:00:00') : undefined;
        query.endTime = query.time[1] ? query.time[1].format('YYYY-MM-DD 23:59:59') : undefined;
      }
      delete query.time
      if (Array.isArray(query.deptId)) {
        query.deptId = query.deptId[query.deptId.length - 1];
      }
      getSeatWorkload(query).then(res => {
        resolve({records: res || [], total: res.length || 0})
      }).catch(reject)
    })
  }

  const getStatusOptions = async() => {
    const companyList = await httpOrgList();
    const serviceList = await getEnums("report", "com.shj.saas.report.enums.crm.AudioLogBrandEnum");
    // const companyList = await getSeatAccountList();
    return Promise.resolve({companyList, serviceList})
  }

  const onCompanyChange = (value) => {
    if (value){
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('deptId', res)
      })
      getAllCompanyMrn({userIdentityFilter: {companyId: value}}).then(res => {
        listRef?.current?.updateSearchData('employ', res)
      })
    } else {
      listRef?.current?.updateSearchData('deptId', [])
      listRef?.current?.updateSearchData('employ', [])
    }
  }

  const onDeptCodeChange = (value) => {
    if (value) {
      getAllCompanyMrn({directlyUnder: {orgId: value[value.length - 1], includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('employ', res)
      })
    } else {
      const companyId = listRef.current.getSearch()?.getFieldValue('orgId')
      if (companyId) {
        getAllCompanyMrn({userIdentityFilter: {companyId}}).then(res => {
          listRef?.current?.updateSearchData('employ', res)
        })
      } else {
        listRef?.current?.updateSearchData('employ', [])
      }
    }
  }

  const extension = {
    request: {fetchList, getStatusOptions},
    events: {onCompanyChange, onDeptCodeChange},
    status: {
      orgDisabled: () => userInfo?.userIdentity?.dataScope !== 'ALL',
    }
  }

  return <SLowcodeList searchMode={'group'} ref={listRef}
                       config={{ ...config, [userInfo?.userIdentity?.dataScope === 'ALL' ? '' : 'searchInitialValues']: {orgId: userInfo.companyId}}}
                       {...extension} />
}